module.exports = __webpack_public_path__ + "img/lesson1.8ba736d3.png";